import isArray from "lodash/isArray";
import isEqual from "lodash/isEqual";
import mergeWith from "lodash/mergeWith";

let cachedObject: any;

const customizer = (object: any, source: any, key: string) => {
    let isCss = key.toLowerCase().endsWith("css");

    const cachedProp = cachedObject?.[key];
    if (cachedProp && isEqual(cachedProp, object)) {
        isCss = true;
    } else {
        cachedObject = undefined;
    }

    if (key === "cssOverrides") {
        cachedObject = object;
    }

    if (isCss && isArray(object)) {
        return object.concat(source);
    }
};

export default <TObject1, TObject2>(object1: TObject1, object2: TObject2): TObject1 & TObject2 => {
    cachedObject = undefined;

    return mergeWith({}, object1, object2, customizer);
};
